import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const Catalogue = lazy(() => import("../pages/catalogue/page"));
const GuidesSubvention = lazy(() => import("../pages/outils/guides-subvention/page"));
const ModelesBudget = lazy(() => import("../pages/outils/modeles-budget/page"));
const GestionProjet = lazy(() => import("../pages/outils/gestion-projet/page"));
const TutelleVente = lazy(() => import("../pages/tutelle-vente/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalogue",
    element: <Catalogue />,
  },
  {
    path: "/outils/guides-subvention",
    element: <GuidesSubvention />,
  },
  {
    path: "/outils/modeles-budget",
    element: <ModelesBudget />,
  },
  {
    path: "/outils/gestion-projet",
    element: <GestionProjet />,
  },
  {
    path: "/tutelle-vente",
    element: <TutelleVente />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;